module.exports = __webpack_public_path__ + "img/m-fukuanguanli.660cf309.svg";